// Module
var code = `<i class="fa fa-check" ng-if="booleanCheckController.ngModel === true"></i> `;
// Exports
module.exports = code;